import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'
import {format} from 'd3'

const DataViewBox = (state, value, wrapText, type, outreachSimulationSelected) => (
  <View style={[styles.quickStat, wrapText && {flex: 1}]}>
    <Text style={styles.quickStatTitle}>{getQuickStatLabel(state, outreachSimulationSelected, type)}</Text>
    <Text style={styles.quickStatValue}>{value >= 0 ? format('.4~s')(value) : '---'}</Text>
  </View>
)

const getQuickStatLabel = (state, outreachSimulationSelected, type) => {
  if (outreachSimulationSelected && type !== -1) {
    return `Total ${state} ${type === 1 ? 'Enrolled' : 'Not Enrolled'}`
  } else {
    return `Selected ${state} ${type === 1 ? 'Adult Population' : 'Unique Addresses'}`
  }
}

const showStateData = (state, value, wrapText, enrolledValue) => {
  const outreachSimulationSelected = value.outreachSimulationSelected
  return (
    <>
      <View style={styles.quickStatDivider} />
      {(enrolledValue === 2 || enrolledValue === 1) &&
        DataViewBox(
          state,
          outreachSimulationSelected ? value.enrolled : value.population,
          wrapText,
          1,
          outreachSimulationSelected
        )}
      {(enrolledValue === 2 || enrolledValue === 0) &&
        DataViewBox(
          state,
          outreachSimulationSelected ? value.notEnrolled : value.unique,
          wrapText,
          2,
          outreachSimulationSelected
        )}
      {outreachSimulationSelected && state !== 'US'
        ? DataViewBox(state, value.unique, wrapText, -1, outreachSimulationSelected)
        : null}
    </>
  )
}

const QuickStat = (quickStatData) => {
  const wrapText = quickStatData.length > 2
  return quickStatData.map((stat) => {
    if (stat.state === 'US' && !stat.value.outreachSimulationSelected) {
      return DataViewBox(stat.state, stat.value, wrapText, 1, stat.value.outreachSimulationSelected)
    }
    return showStateData(stat.state, stat.value, wrapText, stat.value.enrolledValue)
  })
}

export default QuickStat

/**
 * List of functions and their purpose:
 *
 * - DataViewBox: Renders a styled box displaying a quick stat label and its corresponding value.
 * - getQuickStatLabel: Generates a label for quick stats based on state, enrollment status, and type.
 * - showStateData: Displays quick stats for a specific state, including enrolled, not enrolled, and unique addresses.
 * - QuickStat: Maps and renders quick stats for all states, including the US, based on enrollment and population data.
 */
